import { Image, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import Modal from 'components/Modal';

import Loader from './img/loader.svg';
import { WithLoaderModalPropsType } from './types';

import * as S from './styled';

const WithLoaderModal = ({
    img = null,
    title,
    subtitle = 'subscription.waitingModal.pleaseWait.subttile',
    withRoundedCorners = true,
}: WithLoaderModalPropsType) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen customStyles={{ padding: '16px 16px 32px' }} withRoundedCorners={withRoundedCorners}>
            <S.LoaderContainer data-locator="processingBlock">
                {img && <Image maxWidth={72} center alt="emoji" src={img} disableLazyLoad />}
                <Text type="h5" mb={subtitle ? 12 : 24} center dataLocator="processingTitle">
                    {t(title)}
                </Text>
                {subtitle && (
                    <S.Subtitle medium color="text-secondary" mb={24} center dataLocator="processingSubtitle">
                        {t(subtitle)}
                    </S.Subtitle>
                )}
                <S.IconContainer data-locator="processingSpiner">
                    <Loader />
                </S.IconContainer>
            </S.LoaderContainer>
        </Modal>
    );
};

export default WithLoaderModal;
